import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import DiscountAnalysis from "./pages/DiscountAnalysis";
import CreateMappingSheet from "./pages/CreateMappingSheet";
import ProductFeedManagement from "./pages/ProductFeedManagement";
import ProductFeedManagement2 from "./pages/product-feed-management-2";
import AttributeManagement from "./pages/AttributeManagement";
import MainLayout from "./components/MainLayout";
import UserApprovals from "./pages/UserApprovals";
import SupplierProductFeedManagement from "./pages/supplier-product-feed-management";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/mapping-sheet" element={<CreateMappingSheet />} />
            <Route path="/product-feed-management" element={<ProductFeedManagement />} />
            <Route path="/product-feed-management-2" element={<ProductFeedManagement2 />} />
            <Route path="/supplier-product-feed-management" element={<SupplierProductFeedManagement />} />
            <Route path="/attribute-management" element={<AttributeManagement />} />
            <Route path="/attribute-groups" element={<Navigate to="/attribute-management" replace />} />
            <Route path="/discount-analysis" element={<DiscountAnalysis />} />
            <Route path="/user-approvals" element={<UserApprovals />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </MainLayout>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;